/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateCustomisationPayload,
  DirectDebitReminderDto,
  InvoiceRecipientsSettingsDto,
  InvoiceScheduleSettingsDto,
  Update4Payload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class OrganisationCustomisationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags organisation-customisation-controller
   * @name GetByOrganisationId1
   * @request GET:/api/v1/customisation
   */
  getByOrganisationId = (params: RequestParams = {}) =>
    this.http.request<
      (DirectDebitReminderDto | InvoiceRecipientsSettingsDto | InvoiceScheduleSettingsDto)[],
      any
    >({
      path: `/v1/customisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByOrganisationIdPath = '/v1/customisation'
  static getByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags organisation-customisation-controller
   * @name CreateCustomisation
   * @request POST:/api/v1/customisation
   */
  createCustomisation = (data: CreateCustomisationPayload, params: RequestParams = {}) =>
    this.http.request<
      DirectDebitReminderDto | InvoiceRecipientsSettingsDto | InvoiceScheduleSettingsDto,
      any
    >({
      path: `/v1/customisation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCustomisationPath = '/v1/customisation'
  static createCustomisationMethod = 'POST'
  /**
   * No description
   *
   * @tags organisation-customisation-controller
   * @name Update4
   * @request PATCH:/api/v1/customisation
   */
  update = (data: Update4Payload, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/customisation`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updatePath = '/v1/customisation'
  static updateMethod = 'PATCH'
}
